import { defineStore } from "pinia";
import { login as apiLogin, logout as apiLogout, getMe } from "../services/api";
import { useWysiwygStore } from "./wysiwyg";
import { useTicketsViewStore } from "./ticketsView";
import { useSidebarStore } from "./sidebar";
import { useTicketFormStore } from "./ticketForm";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    // Initialize from localStorage so state persists on refresh
    user: JSON.parse(localStorage.getItem("user-info") || "null"),
    token: localStorage.getItem("user-token") || null,
    isLoading: false,
    profileLoaded: false, // ← new flag to track if profile has been loaded
  }),

  getters: {
    isAgent: (state) => state.user?.role === 'agent',
    isAdmin: (state) => state.user?.role === 'admin',
    isAuthenticated: (state) => !!state.token,
  },

  actions: {
    async login(email: string, password: string) {
      this.isLoading = true;
      try {
        // 1. Call your existing api.ts logic
        console.log("[auth] login() called");
        await apiLogin(email, password);

        // 2. Update the Pinia state with the data api.ts just saved to localStorage
        this.token = localStorage.getItem("user-token");
        this.user = JSON.parse(localStorage.getItem("user-info") || "null");

        return true;
      } finally {
        this.isLoading = false;
      }
    },

    async logout() {
      try {
        await apiLogout();
      } catch {
        // still clear local state even if backend call fails
      } finally {
        this.token = null;
        this.user = null;
        this.profileLoaded = false;
        // Reset wysiwyg store
        const wysiwygStore = useWysiwygStore();
        wysiwygStore.$reset();

        // Reset tickets view store
        const ticketsViewStore = useTicketsViewStore();
        ticketsViewStore.reset();

        // Reset sidebar store
        const sidebarStore = useSidebarStore();
        sidebarStore.reset();

        // Reset ticket form modal store
        const ticketFormStore = useTicketFormStore();
        ticketFormStore.clear();
      }
    },
    async fetchProfile() {
      console.log("[auth] fetchProfile() called", {
        profileLoaded: this.profileLoaded,
        isLoading: this.isLoading,
        hasToken: !!this.token,
      });
      if (this.profileLoaded || !this.token || this.isLoading) {
        console.log("[auth] fetchProfile() early return");
        return;
      }

      this.isLoading = true;
      try {
        console.log("[auth] fetchProfile() → calling getMe()");
        const response = await getMe();
        this.user = response.data.data;
        this.profileLoaded = true;
        localStorage.setItem("user-info", JSON.stringify(this.user));
      } catch (err) {
        console.error("[auth] Failed to load profile", err);
      } finally {
        console.log("[auth] fetchProfile() finished");
        this.isLoading = false;
      }
    },

    
  },
});